const TrendChart = ({ data, label, color, period }) => {
  if (!data || data.length === 0) return <div>No data available</div>;

  // Aggregate data based on period
  const aggregateData = (data, period) => {
    if (period === "weekly" || period === "daily") {
      // Show raw daily data
      return data.map(item => ({
        value: typeof item === "object" ? item.value : item,
        label: typeof item === "object"
          ? new Date(item.date).toLocaleDateString("en-US", { month: "short", day: "numeric" })
          : item,
      }));
    }

    if (period === "monthly") {
      // Group daily data into weeks
      const weeks = {};
      data.forEach(item => {
        const date = new Date(item.date);
        // Get week number within the month (1-5)
        const weekNum = Math.ceil(date.getDate() / 7);
        const key = `${date.getFullYear()}-${date.getMonth()}-W${weekNum}`;
        if (!weeks[key]) {
          weeks[key] = {
            value: 0,
            label: `W${weekNum} ${date.toLocaleDateString("en-US", { month: "short" })}`,
          };
        }
        weeks[key].value += typeof item === "object" ? item.value : item;
      });
      return Object.values(weeks);
    }

    if (period === "quarterly") {
      // Group into months
      const months = {};
      data.forEach(item => {
        const date = new Date(item.date);
        const key = `${date.getFullYear()}-${date.getMonth()}`;
        if (!months[key]) {
          months[key] = {
            value: 0,
            label: date.toLocaleDateString("en-US", { month: "short", year: "2-digit" }),
          };
        }
        months[key].value += typeof item === "object" ? item.value : item;
      });
      return Object.values(months);
    }

    if (period === "yearly") {
      // Group into months
      const months = {};
      data.forEach(item => {
        const date = new Date(item.date);
        const key = `${date.getFullYear()}-${date.getMonth()}`;
        if (!months[key]) {
          months[key] = {
            value: 0,
            label: date.toLocaleDateString("en-US", { month: "short" }),
          };
        }
        months[key].value += typeof item === "object" ? item.value : item;
      });
      return Object.values(months);
    }

    return data;
  };

  const aggregated = aggregateData(data, period);
  const normalizedData = aggregated.map(item => item.value);
  const dateLabels = aggregated.map(item => item.label);
  const maxValue = Math.max(...normalizedData);

  return (
    <div className="trend-chart">
      <div className="chart-bars">
        {normalizedData.map((value, index) => {
          const height = maxValue > 0 ? (value / maxValue) * 100 : 5;
          return (
            <div key={index} className="chart-bar-wrapper">
              <div
                className="chart-bar"
                style={{ height: `${height}%`, backgroundColor: color }}
                title={`${dateLabels[index]}: ${value}`}
              >
                {value > 0 && <span className="bar-value">{value}</span>}
              </div>
            </div>
          );
        })}
      </div>

      <div className="chart-labels">
        {dateLabels.map((lbl, index) => (
          <div key={index} className="bar-label">{lbl}</div>
        ))}
      </div>
    </div>
  );
};

export default TrendChart;